/*
 * Entry point of the application.
 * Only platform bootstrapping code should be here.
 * For app-specific initialization, use `app/app.component.ts`.
 */

import { enableProdMode } from '@angular/core';
import { bootstrapApplication } from '@angular/platform-browser';

import { environment } from '@env/environment';
import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';

if (environment.production) {
  enableProdMode();
}

// Log build version on startup
fetch('/version.json?_t=' + Date.now())
  .then((res) => (res.ok ? res.json() : Promise.reject(new Error(`HTTP ${res.status}`))))
  .then((info: { version: string; hash: string; buildTime: string }) => {
    // eslint-disable-next-line no-console
    console.log(
      `%c Hypecast Master Admin v${info.version} (${info.hash}) — built ${info.buildTime} `,
      'background:#0029FF;color:#fff;border-radius:3px;padding:2px 6px',
    );
  })
  .catch(() => {
    // version.json not available (local dev without prestart, or fetch failed) — silently ignore
  });

// eslint-disable-next-line no-console
bootstrapApplication(AppComponent, appConfig).catch((error: unknown) => console.error(error));
